export default __webpack_public_path__ + "static/media/left-arrow.641906d2.svg";